import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { FiTrash2 } from "react-icons/fi";
import { UserContext } from "../context/userContext";
import { authHeaders } from "../constants";

const DeletePost = ({ postId: id, onDeleted }) => {
  const navigate = useNavigate();
  const { currentUser } = useContext(UserContext);
  const token = currentUser?.token;
  const location = useLocation();

  const removePost = async () => {
    if (!token) return navigate("/login");
    if (!window.confirm("Delete this post? This can't be undone.")) return;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/posts/${id}`,
        authHeaders(token)
      );
      if (response.status === 200) {
        if (onDeleted) onDeleted(id);
        else if (location.pathname !== `/myposts/${currentUser.id}`) navigate("/");
      }
    } catch (error) {
      console.log("couldn't delete post");
    }
  };

  return (
    <button type="button" className="btn btn--sm btn--danger" onClick={removePost}>
      <FiTrash2 /> Delete
    </button>
  );
};

export default DeletePost;
